export enum AppEmbedData_AppType {
  PRODUCT = "PRODUCT",
  EVENT = "EVENT",
  BOOKING = "BOOKING",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AppEmbedData_ImageStyles_Position {
  /** START - Image positioned at the start (left in LTR layouts, right in RTL layouts) */
  START = "START",
  /** END - Image positioned at the end (right in LTR layouts, left in RTL layouts) */
  END = "END",
  /** TOP - Image positioned at the top */
  TOP = "TOP",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AppEmbedData_ImageStyles_AspectRatio {
  /** SQUARE - 1:1 aspect ratio */
  SQUARE = "SQUARE",
  /** RECTANGLE - 16:9 aspect ratio */
  RECTANGLE = "RECTANGLE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AppEmbedData_ImageStyles_Resizing {
  /** FILL - Fill the container, may crop the image */
  FILL = "FILL",
  /** FIT - Fit the image within the container */
  FIT = "FIT",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AppEmbedData_RibbonStyles_Placement {
  /** IMAGE - Ribbon placed on the image */
  IMAGE = "IMAGE",
  /** PRODUCT_INFO - Ribbon placed on the product information */
  PRODUCT_INFO = "PRODUCT_INFO",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AppEmbedData_CardStyles_Type {
  /** CONTAINED - Card with visible border and background */
  CONTAINED = "CONTAINED",
  /** FRAMELESS - Card without visible border */
  FRAMELESS = "FRAMELESS",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AppEmbedData_CardStyles_Alignment {
  /** START - Content aligned to start (left in LTR layouts, right in RTL layouts) */
  START = "START",
  /** CENTER - Content centered */
  CENTER = "CENTER",
  /** END - Content aligned to end (right in LTR layouts, left in RTL layouts) */
  END = "END",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export enum AppEmbedData_CardStyles_Layout {
  /** STACKED - Elements stacked vertically */
  STACKED = "STACKED",
  /** SIDE_BY_SIDE - Elements arranged horizontally */
  SIDE_BY_SIDE = "SIDE_BY_SIDE",
  UNRECOGNIZED = "UNRECOGNIZED",
}